<template>
  <div
    class="tw-mt-6 tw-box-border tw-flex tw-flex-row tw-space-x-4 tw-rounded-lg tw-border-2 tw-border-green-700 tw-bg-green-50 tw-p-4"
  >
    <font-awesome-icon :icon="['far', 'check-circle']" class="fa-2x tw-mt-2 tw-text-green-700" />
    <div class="tw-flex tw-flex-col tw-text-green-700">
      <div class="tw-font-semibold">Verified reviews</div>
      <div class="tw-mt-1 tw-text-sm">
        <p>
          All reviews are provided by customers who have completed their booking through the
          <a href="https://www.nabooki.com" target="_blank" class="tw-underline">Nabooki platform</a>
          <span>.</span>
        </p>
      </div>
    </div>
  </div>
</template>
